export const API_PREFIX = '/api/v1/yavagro'

export const SERVICES_PREFIXES_LIST = ['vacancies', 'vaca', 'news', 'employers', 'internships'] as const
